var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { useEffect, useRef, useState } from 'react';
import { Outlet, useLocation, useNavigate, matchPath } from 'react-router-dom';
import Logo from '../../../../images/logo_partners_white.svg';
import { RoutePaths } from '../../config/routes';
import classNames from 'classnames';
import AvatarInput from '../../components/Fields/AvatarInput';
import { useValidation, ValidationString } from '../../hooks/useValidation';
import * as yup from 'yup';
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import Heading from '../../components/Typography/Heading';
import Button from '../../components/Button';
import { Edit2, Eye, Check, CheckCircle } from 'react-feather';
import Paragraph from '../../components/Typography/Paragraph';
import { useUser } from '../../hooks/useUser';
import axiosInstance from '../../config/axios';
import { api } from '../../config/api';
import { serialize } from 'object-to-formdata';
import Drawer from '../../components/Drawer';
import TextArea from '../../components/Fields/TextArea';
import { toast } from 'react-toastify';
import { deepEqual, pick } from '../../utils/Objects';
import ModalBasic from '../../components/Modal/Basic';
import { Shape5 } from '../../components/CustomIcon';
import FadeIn from '../../components/Animation/FadeIn';
import ScrollToTop from '../../components/ScrollToTop';
import { usePlaceholder } from '../../hooks/usePlaceholder';
import Seo from '../../components/Seo';
import { useSignOut } from 'react-auth-kit';
import { useAuth } from '../../hooks/useAuth';
var classes = {
    navItem: {
        base: 'p-4 text-white block transition-colors rounded-lg cursor-pointer font-medium',
        active: 'bg-secondary-04 text-black',
    },
};
var Dashboard = function () {
    var navigate = useNavigate();
    var location = useLocation();
    var signOut = useSignOut();
    var isAuthenticated = useAuth().isAuthenticated;
    var _a = useValidation(), avatarRequired = _a.avatarRequired, textRequired = _a.textRequired;
    var _b = useUser(), getUserStorage = _b.getUserStorage, setUserStorage = _b.setUserStorage, removeUserStorage = _b.removeUserStorage;
    var placeholders = usePlaceholder();
    var _c = useState(false), loading = _c[0], setLoading = _c[1];
    var _d = useState(), user = _d[0], setUser = _d[1];
    var _e = useState(location.state), currentState = _e[0], setCurrentState = _e[1];
    var _f = useState(currentState === null || currentState === void 0 ? void 0 : currentState.success), modal = _f[0], setModal = _f[1];
    var _g = useState(false), drawer = _g[0], setDrawer = _g[1];
    var _h = useState(true), isProfessional = _h[0], setIsProfessional = _h[1];
    var scrollRef = useRef(null);
    var navItemsPro = [
        {
            path: RoutePaths.DASHBOARD,
            name: 'Mon profil public',
        },
        {
            path: RoutePaths.DASHBOARD_PROFILE,
            name: 'Mes informations principales',
        },
        {
            path: RoutePaths.DASHBOARD_CONTACT,
            name: 'Mes coordonnées',
        },
        {
            path: RoutePaths.DASHBOARD_LOGIN_DETAILS,
            name: 'Mes identifiants',
        },
        {
            path: RoutePaths.DASHBOARD_FAVORITES,
            name: 'Profils favoris',
        },
    ];
    var navItemsVisitor = [
        {
            path: RoutePaths.DASHBOARD_PROFILE,
            name: 'Mes informations principales',
        },
        {
            path: RoutePaths.DASHBOARD_LOGIN_DETAILS,
            name: 'Mes identifiants',
        },
        {
            path: RoutePaths.DASHBOARD_FAVORITES,
            name: 'Profils favoris',
        },
    ];
    var _j = useState(navItemsPro), nav = _j[0], setNav = _j[1];
    var pathIsMatching = function (target) {
        return !!matchPath(location.pathname, target);
    };
    var handleNavClick = function (target) {
        if (!pathIsMatching(target)) {
            navigate(target);
        }
    };
    var schemaTitle = yup.object().shape({
        profile_title: textRequired,
    });
    var schemaAvatar = yup.object().shape({
        avatar: avatarRequired,
    });
    var _k = useForm({
        resolver: yupResolver(schemaTitle),
        defaultValues: { profile_title: user === null || user === void 0 ? void 0 : user.profile_title },
    }), handleTitleSubmit = _k.handleSubmit, controlTitle = _k.control, resetTitle = _k.reset;
    var _l = useForm({
        resolver: yupResolver(schemaAvatar),
        defaultValues: { avatar: user === null || user === void 0 ? void 0 : user.avatar },
    }), handleAvatarSubmit = _l.handleSubmit, controlAvatar = _l.control, resetAvatar = _l.reset;
    var onTitleSubmit = function (data) { return __awaiter(void 0, void 0, void 0, function () {
        var formData, response, error_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (deepEqual(data, pick(user, 'profile_title')))
                        return [2 /*return*/];
                    setLoading(true);
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, 4, 5]);
                    formData = serialize(data, { indices: true });
                    return [4 /*yield*/, axiosInstance.post(api.user.update, formData)];
                case 2:
                    response = _a.sent();
                    handleUser(response.data);
                    resetTitle(pick(response.data, 'profile_title'));
                    toast.success('Votre titre de profil a bien été mis à jour');
                    return [3 /*break*/, 5];
                case 3:
                    error_1 = _a.sent();
                    handleFormError(error_1);
                    return [3 /*break*/, 5];
                case 4:
                    setLoading(false);
                    setDrawer(false);
                    return [7 /*endfinally*/];
                case 5: return [2 /*return*/];
            }
        });
    }); };
    var onAvatarSubmit = function (data) { return __awaiter(void 0, void 0, void 0, function () {
        var formData, response, error_2;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (deepEqual(data, pick(user, 'avatar')))
                        return [2 /*return*/];
                    setLoading(true);
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, 4, 5]);
                    formData = serialize(data, { indices: true });
                    return [4 /*yield*/, axiosInstance.post(api.user.update, formData)];
                case 2:
                    response = _a.sent();
                    handleUser(response.data);
                    resetAvatar(pick(response.data, 'avatar'));
                    toast.success('Votre avatar a bien été mis à jour');
                    return [3 /*break*/, 5];
                case 3:
                    error_2 = _a.sent();
                    handleFormError(error_2);
                    return [3 /*break*/, 5];
                case 4:
                    setLoading(false);
                    return [7 /*endfinally*/];
                case 5: return [2 /*return*/];
            }
        });
    }); };
    var handleUser = function (user) {
        setUserStorage(user);
        setUser(user);
        setIsProfessional((user === null || user === void 0 ? void 0 : user.category.slug) === 'professional');
        setNav((user === null || user === void 0 ? void 0 : user.category.slug) == 'visitor' ? navItemsVisitor : navItemsPro);
    };
    var handleSessionExpired = function () {
        if (isAuthenticated())
            return;
        removeUserStorage();
        signOut();
        navigate(RoutePaths.SIGN_IN, { replace: true, state: { expiredSession: true } });
    };
    var handleFormError = function (error) {
        var _a;
        if (((_a = error === null || error === void 0 ? void 0 : error.response) === null || _a === void 0 ? void 0 : _a.status) === 403) {
            handleSessionExpired();
        }
        else {
            toast.error(ValidationString.PROFILE);
        }
    };
    useEffect(function () {
        if (!getUserStorage()) {
            axiosInstance
                .get(api.user.get)
                .then(function (response) {
                handleUser(response.data);
                resetAvatar(response.data);
                resetTitle(response.data);
            })
                .catch(function (error) {
                handleFormError(error);
            });
        }
        else {
            handleUser(getUserStorage());
            resetAvatar(getUserStorage());
            resetTitle(getUserStorage());
        }
    }, []);
    if (!user)
        return null;
    return (<FadeIn>
      <Seo title={"Bienvenue dans votre espace personnel ".concat(user.first_name)}/>
      <div className="relative flex w-full overflow-hidden lg:h-[calc(100vh-120px)] max-lg:flex-col">
        <div className="relative w-full overflow-hidden bg-secondary-01 lg:h-full lg:w-[24rem] xl:w-[28rem]">
          <div className="absolute bottom-0 h-28 w-28 bg-secondary-02 lg:left-0 lg:rounded-tr-full max-lg:right-0 max-lg:rounded-tl-full"/>
          <div className="h-full overflow-y-auto py-10 lg:py-16">
            <div className="container relative">
              <a href="/" className="lg:hidden" aria-label="Navigation vers la page d'accueil">
                <img src={Logo} alt="Logo de Majeures" width={245} height={55}/>
              </a>

              <div className="flex items-center max-lg:mt-8">
                <form>
                  <AvatarInput name="avatar" control={controlAvatar} submit={handleAvatarSubmit(onAvatarSubmit)} loading={loading} border/>
                </form>
                <div className="dark ml-4 flex flex-1 flex-col items-start">
                  <Heading level={6} className="flex">
                    {user === null || user === void 0 ? void 0 : user.full_name}
                    {(user === null || user === void 0 ? void 0 : user.certified_account) && (<div className="flex-center ml-1 mt-1 h-4 w-4 rounded-full bg-alert-success">
                        <Check size={12}/>
                      </div>)}
                  </Heading>
                  {isProfessional && (<Button onClick={function () { return (window.location.href = user === null || user === void 0 ? void 0 : user.url); }} type="inline" icon={Eye} side="start" className="text-sm text-white">
                      Voir mon profil public
                    </Button>)}
                </div>
              </div>

              {(user === null || user === void 0 ? void 0 : user.profile_title) && (<div className="dark group mt-6 flex w-full cursor-pointer items-center rounded-lg border border-white p-4" onClick={function () {
                setDrawer(true);
            }}>
                  <Paragraph size="sm" className="flex-1 text-center text-sm">
                    {user === null || user === void 0 ? void 0 : user.profile_title}
                  </Paragraph>
                  <Edit2 size={20} className="ml-2 text-gray-300 transition-colors lg:group-hover:text-white"/>
                </div>)}

              <Drawer handleClose={function () { return setDrawer(false); }} open={drawer}>
                <div className="px-drawer">
                  <div className="flex items-center justify-between">
                    <Heading level={2} type="h5" className="mb-2">
                      Titre de votre profil
                    </Heading>
                  </div>
                  <Paragraph size="sm" className="mt-2 text-gray-700">
                    Indiquez un titre qui permet d’identifier facilement votre activité ou vos
                    compétences.
                  </Paragraph>
                  <form onSubmit={handleTitleSubmit(onTitleSubmit)}>
                    <div className="mt-8 flex flex-col gap-3">
                      <div className="mt-4 flex flex-col gap-3">
                        <TextArea name="profile_title" placeholder={placeholders.profileTitle} control={controlTitle} required max={90}/>

                        <Button submit loading={loading} className="mt-10">
                          Sauvegarder
                        </Button>
                      </div>
                    </div>
                  </form>
                </div>
              </Drawer>

              <nav className="dark mt-12 max-lg:hidden">
                <ul className="flex flex-col">
                  {nav.map(function (item) { return (<li key={item.path} onClick={function () { return handleNavClick(item.path); }} className={classNames(classes.navItem.base, pathIsMatching(item.path) && classes.navItem.active)}>
                      {item.name}
                    </li>); })}
                  <li onClick={function () { return (window.location.href = RoutePaths.BOOKMARKS); }} className={classes.navItem.base}>
                    Mes recherches
                  </li>
                </ul>
              </nav>
            </div>
          </div>
        </div>

        <div className="z-1 w-full bg-secondary-04 lg:hidden">
          <div className="container">
            <select className="w-full bg-secondary-04 py-4 focus:outline-none" name="nav" id="nav" onChange={function (e) {
            return e.target.value === RoutePaths.BOOKMARKS
                ? (window.location.href = RoutePaths.BOOKMARKS)
                : navigate(e.target.value);
        }} defaultValue={location.pathname}>
              {nav.map(function (item) { return (<option key={item.path} value={item.path}>
                  {item.name}
                </option>); })}
              <option value={RoutePaths.BOOKMARKS}>Mes recherches</option>
            </select>
          </div>
        </div>

        <div className="h-full flex-1 overflow-auto bg-white" ref={scrollRef}>
          <ScrollToTop wrapper={scrollRef}/>
          <div className="container">
            <Outlet context={{ user: user, handleUser: handleUser, handleFormError: handleFormError }}/>
          </div>
        </div>

        <ModalBasic handleClose={function () { return setModal(false); }} open={modal} dark={true} className="md:max-w-[550px] max-md:flex max-md:overflow-hidden" subWrapperClassName="flex" contentClassName="flex">
          <Shape5 size={600} className="absolute top-[38%] left-[-480px] rotate-[-135deg] md:top-[-250px] md:left-[-430px]"/>
          <div className="relative mb-4 flex flex-col items-center text-center md:mb-12 md:px-10 max-md:mt-12">
            <CheckCircle size={72} className="text-white"/>
            <Heading level={4} className="mt-6">
              Félicitations {user === null || user === void 0 ? void 0 : user.first_name} !
            </Heading>
            {isProfessional && (<>
                <Paragraph size="lg">Vous êtes référencé·e sur Majeur·e·s</Paragraph>
                <Paragraph className="mt-6 max-sm:mb-auto">
                  Pour améliorer votre visibilité, vous pouvez continuer de remplir votre profil
                  depuis votre compte
                </Paragraph>
                <Button type="primary" className="mt-12 w-full" onClick={function () { return setModal(false); }}>
                  Accéder à mon compte
                </Button>
              </>)}

            {!isProfessional && (<>
                <Paragraph size="lg">Votre compte a bien été créé</Paragraph>
                <Paragraph className="mt-6 max-sm:mb-auto">
                  Vous pouvez à présent contacter l’ensemble des professionnel·les référencé·es sur
                  Majeur·e·s
                </Paragraph>
                <div className="mt-10 flex w-full flex-col gap-4">
                  <Button type="primary" className="w-full" onClick={function () { return (window.location.href = 'annuaire'); }}>
                    Trouver un profil
                  </Button>
                  <Button type="outlined" className="w-full" onClick={function () { return setModal(false); }}>
                    Accéder à mon compte
                  </Button>
                </div>
              </>)}
          </div>
        </ModalBasic>
      </div>
    </FadeIn>);
};
export default Dashboard;
